// /* eslint-disable import/no-named-as-default */
// /* eslint-disable no-shadow */
// import React, { Component } from "react";
// import PropTypes from "prop-types";
// import { connect } from "react-redux";
// import {
//   loadEmployerAnalytics,
//   loadEmployerPipelineWidget,
//   loadEmployerTimeToHireWidget,
//   loadEmployerOfferToPlacementWidget,
//   loadEmployerSpendPerSectorWidget,
//   loadEmployerTotalJobsPostedWidget,
//   loadEmployerTotalJobsPerSectorWidget,
//   loadEmployerTimeToHireTimelineWidget,
//   loadEmployerApplicationActionsTrackingWidget,
//   setAllWidgetsLoading,
//   selectTab,
// } from "../../../actions/employerAnalyticsActions";
// import ErrorBoundary from "../../shared/error/ErrorBoundary";
// import FullScreenLoading from "../../shared/loaders/FullScreenLoading";
// import Pipeline from "./Pipeline";
// import TimeToHire from "./TimeToHire";
// import OfferToPlacement from "./OfferToPlacement";
// import SpendPerSector from "./SpendPerSector";
// import TotalJobsPosted from "./TotalJobsPosted";
// import TotalJobsPerSector from "./TotalJobsPerSector";
// import TimeToHireTimeline from "./TimeToHireTimeline";
// import ApplicationActionsTracking from "./ApplicationActionsTracking";
// import {
//   Wrapper,
//   Inner,
//   Charts,
//   ChartGroup,
// } from "../styles/employer-analytics-styles";

// interface IChartsPageProps {
//   loadEmployerAnalytics: () => void;
//   loadEmployerPipelineWidget: (employerId: number | null) => void;
//   loadEmployerTimeToHireWidget: (employerId: number | null) => void;
//   loadEmployerOfferToPlacementWidget: (employerId: number | null) => void;
//   loadEmployerSpendPerSectorWidget: (employerId: number | null) => void;
//   loadEmployerTotalJobsPostedWidget: (employerId: number | null) => void;
//   loadEmployerTotalJobsPerSectorWidget: (employerId: number | null) => void;
//   loadEmployerTimeToHireTimelineWidget: (employerId: number | null) => void;
//   loadEmployerApplicationActionsTrackingWidget: (
//     employerId: number | null
//   ) => void;
//   setAllWidgetsLoading: () => void;
//   selectTab: (tabType: string) => void;
//   loading: boolean;
//   isPremiumOrPortalUser: boolean;
//   isPortalUser: boolean;
//   isRootParentEmployer: boolean;
//   hubAdminPresent: boolean;
//   datePickerActive: boolean;
//   employerIdFilter?: number | null;
// }

// export class ChartsPage extends Component<IChartsPageProps, unknown> {
//   static propTypes = {
//     loadEmployerAnalytics: PropTypes.func.isRequired,
//     loadEmployerPipelineWidget: PropTypes.func.isRequired,
//     loadEmployerTimeToHireWidget: PropTypes.func.isRequired,
//     loadEmployerOfferToPlacementWidget: PropTypes.func.isRequired,
//     loadEmployerSpendPerSectorWidget: PropTypes.func.isRequired,
//     loadEmployerTotalJobsPostedWidget: PropTypes.func.isRequired,
//     loadEmployerTotalJobsPerSectorWidget: PropTypes.func.isRequired,
//     loadEmployerTimeToHireTimelineWidget: PropTypes.func.isRequired,
//     loadEmployerApplicationActionsTrackingWidget: PropTypes.func.isRequired,
//     setAllWidgetsLoading: PropTypes.func.isRequired,
//     selectTab: PropTypes.func.isRequired,
//     loading: PropTypes.bool.isRequired,
//     isPremiumOrPortalUser: PropTypes.bool.isRequired,
//     isPortalUser: PropTypes.bool.isRequired,
//     hubAdminPresent: PropTypes.bool.isRequired,
//     datePickerActive: PropTypes.bool.isRequired,
//     isRootParentEmployer: PropTypes.bool.isRequired,
//     employerIdFilter: PropTypes.number,
//   };

//   static defaultProps = {
//     employerIdFilter: null,
//   };

//   componentDidMount(): void {
//     const yourPerformanceLink: HTMLElement = document.getElementById(
//       "your-performance-link"
//     );
//     if (yourPerformanceLink) yourPerformanceLink.classList.add("active");

//     const {
//       loadEmployerAnalytics,
//       isPremiumOrPortalUser,
//       hubAdminPresent,
//       selectTab,
//     } = this.props;

//     this.loadWidgets();
//     loadEmployerAnalytics();
//     selectTab("employer");

//     if (!isPremiumOrPortalUser && !hubAdminPresent) {
//       document.body.classList.add("no-scroll");
//     }
//   }

//   componentDidUpdate(): void {
//     this.loadWidgets();
//   }

//   componentWillUnmount(): void {
//     const yourPerformanceLink: HTMLElement = document.getElementById(
//       "your-performance-link"
//     );
//     if (yourPerformanceLink) yourPerformanceLink.classList.remove("active");
//   }

//   loadWidgets(): void {
//     const {
//       loadEmployerPipelineWidget,
//       loadEmployerTimeToHireWidget,
//       loadEmployerOfferToPlacementWidget,
//       loadEmployerSpendPerSectorWidget,
//       loadEmployerTotalJobsPostedWidget,
//       loadEmployerTotalJobsPerSectorWidget,
//       loadEmployerTimeToHireTimelineWidget,
//       loadEmployerApplicationActionsTrackingWidget,
//       setAllWidgetsLoading,
//       employerIdFilter,
//     } = this.props;

//     setAllWidgetsLoading();

//     loadEmployerPipelineWidget(employerIdFilter);
//     loadEmployerTimeToHireWidget(employerIdFilter);
//     loadEmployerOfferToPlacementWidget(employerIdFilter);
//     loadEmployerSpendPerSectorWidget(employerIdFilter);
//     loadEmployerTotalJobsPostedWidget(employerIdFilter);
//     loadEmployerTotalJobsPerSectorWidget(employerIdFilter);
//     loadEmployerTimeToHireTimelineWidget(employerIdFilter);
//     loadEmployerApplicationActionsTrackingWidget(employerIdFilter);
//   }

//   render(): React.ReactNode {
//     const {
//       loading,
//       isPremiumOrPortalUser,
//       isPortalUser,
//       hubAdminPresent,
//       datePickerActive,
//       isRootParentEmployer,
//     } = this.props;

//     const tabsAreVisible = isPortalUser && !isRootParentEmployer;

//     return (
//       <ErrorBoundary>
//         {loading ? (
//           <FullScreenLoading />
//         ) : (
//           <Wrapper tabs={tabsAreVisible}>
//             <Inner
//               id="employer-analytics-inner"
//               datePickerActive={datePickerActive}
//             >
//               <Charts
//                 isPremiumOrPortalUser={isPremiumOrPortalUser}
//                 hubAdminPresent={hubAdminPresent}
//               >
//                 <Pipeline />
//                 <ChartGroup>
//                   <TimeToHire />
//                   <OfferToPlacement />
//                 </ChartGroup>
//               </Charts>
//               <Charts
//                 isPremiumOrPortalUser={isPremiumOrPortalUser}
//                 hubAdminPresent={hubAdminPresent}
//               >
//                 <SpendPerSector />
//                 <TotalJobsPosted />
//               </Charts>
//               <Charts
//                 isPremiumOrPortalUser={isPremiumOrPortalUser}
//                 hubAdminPresent={hubAdminPresent}
//               >
//                 <TotalJobsPerSector />
//                 <TimeToHireTimeline />
//               </Charts>
//               <Charts
//                 isPremiumOrPortalUser={isPremiumOrPortalUser}
//                 hubAdminPresent={hubAdminPresent}
//               >
//                 <ApplicationActionsTracking />
//               </Charts>
//             </Inner>
//           </Wrapper>
//         )}
//       </ErrorBoundary>
//     );
//   }
// }

// interface IReduxState {
//   employerAnalytics: {
//     loading: boolean;
//     isPremiumOrPortalUser: boolean;
//     datePickerActive: boolean;
//     isRootParentEmployer: boolean;
//   };
//   candidateRecord: {
//     candidateData: unknown;
//   };
// }

// const mapStateToProps = (state: IReduxState) => ({
//   loading: state.employerAnalytics.loading,
//   candidateData: state.candidateRecord.candidateData,
//   isPremiumOrPortalUser: state.employerAnalytics.isPremiumOrPortalUser,
//   datePickerActive: state.employerAnalytics.datePickerActive,
//   isRootParentEmployer: state.employerAnalytics.isRootParentEmployer,
// });

// export default connect(mapStateToProps, {
//   // I think this must be a bug in eslint - some of these values
//   // it has a problem with because they are implicit any - but
//   // ALL these values are technically implicit any, so really
//   // it should have a problem with all of them
//   /* eslint-disable @typescript-eslint/no-unsafe-assignment */
//   loadEmployerAnalytics,
//   loadEmployerPipelineWidget,
//   loadEmployerTimeToHireWidget,
//   loadEmployerOfferToPlacementWidget,
//   loadEmployerSpendPerSectorWidget,
//   loadEmployerTotalJobsPostedWidget,
//   loadEmployerTotalJobsPerSectorWidget,
//   loadEmployerTimeToHireTimelineWidget,
//   loadEmployerApplicationActionsTrackingWidget,
//   setAllWidgetsLoading,
//   selectTab,
//   /* eslint-enable @typescript-eslint/no-unsafe-assignment */
// })(ChartsPage);
